import { render, staticRenderFns } from "./BidMarketContextPanel.vue?vue&type=template&id=e2ffeb6a&scoped=true"
import script from "./BidMarketContextPanel.vue?vue&type=script&lang=js"
export * from "./BidMarketContextPanel.vue?vue&type=script&lang=js"
import style0 from "./BidMarketContextPanel.vue?vue&type=style&index=0&id=e2ffeb6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ffeb6a",
  null
  
)

export default component.exports